import {Card, CardContent, CardHeader} from "@common/components/Card.tsx";

export function CompanyAnalysisView() {
    return (
        <Card>
            <CardHeader>
                <h2 className="text-xl font-semibold text-foreground">Company Analysis</h2>
            </CardHeader>
            <CardContent>
                <p>Coming soon...</p>
            </CardContent>
        </Card>
    );
}

export default CompanyAnalysisView;